import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-8"
}
const _hoisted_2 = {
  key: 1,
  class: "p-4"
}
const _hoisted_3 = {
  key: 0,
  class: "flex flex-row justify-center space-x-3 bg-gray-50 rounded py-1 mb-2 items-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-7 w-7 text-yellow-300",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor",
  "stroke-width": "2"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
  })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "font-semibold" }, " Please select the workflow stages ", -1)
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "px-5 py-2 rounded-full bg-primary-light flex flew-row items-center justify-between w-full" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-base font-bold" }, " You are now editing the workflow of this job. These are the stages that candidates need to go through in the recruitment process. ", -1)
const _hoisted_9 = { class: "flex space-x-3" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm" }, " Done editing ", -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "pt-5 flex flex-row space-x-6 justify-center items-center w-full"
}
const _hoisted_13 = { class: "text-lg opacity-50" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-300 pt-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_15 = { class: "text-lg" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-300 pt-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_17 = { class: "text-lg opacity-50" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-6 w-6 text-gray-300 pt-1",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M9 5l7 7-7 7"
  })
], -1)
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-row items-center\"><span class=\"text-lg opacity-50\">Offer*</span><svg xmlns=\"http://www.w3.org/2000/svg\" class=\"h-6 w-6 text-gray-300 pt-1\" fill=\"none\" viewBox=\"0 0 24 24\" stroke=\"currentColor\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 5l7 7-7 7\"></path></svg></div><span class=\"text-lg opacity-50\">Hired*</span>", 2)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "flex flex-row w-full mt-2 p-1 text-sm text-yellow-700 rounded-lg dark:bg-yellow-100 dark:text-yellow-400 text-right",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Note:"),
    /*#__PURE__*/_createTextVNode(" The mandatory stages are marked with * ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!

  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Loading, {
          active: _ctx.isLoading,
          "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
          "can-cancel": false,
          loader: "spinner",
          color: "#8908F9",
          width: 80,
          height: 80,
          "is-full-page": false
        }, null, 8, ["active"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_ctx.countSubmit === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              type: "submit",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveWorkflow && _ctx.saveWorkflow(...args))),
              class: "bg-primary px-5 py-2 text-white rounded-full"
            }, _hoisted_11)
          ])
        ]),
        (_ctx.stagesRequired && _ctx.stagesRequired.length > 0 && _ctx.stagesRequired)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstJoin, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-row items-center",
                  key: item
                }, [
                  _createElementVNode("span", _hoisted_13, _toDisplayString(item), 1),
                  _hoisted_14
                ]))
              }), 128)),
              _createVNode(_component_CheckBoxGroup, {
                fieldId: _ctx.stagesRequired && _ctx.stagesRequired[0]?.id,
                names: _ctx.stageValues,
                "onUpdate:names": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stageValues) = $event)),
                value: _ctx.stagesRequired && _ctx.stagesRequired[0]?.id
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.stagesRequired && _ctx.stagesRequired[0]?.name), 1),
                  _hoisted_16
                ]),
                _: 1
              }, 8, ["fieldId", "names", "value"]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondJoin, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "flex flex-row items-center",
                  key: item
                }, [
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item), 1),
                  _hoisted_18
                ]))
              }), 128)),
              _hoisted_19
            ]))
          : _createCommentVNode("", true),
        _hoisted_21
      ]))
}